import { FC, useState } from 'react';
import { useSelector } from 'react-redux';
// import toast, { Toaster } from 'react-hot-toast';

import clsx from 'clsx';

// import { generateStyles } from '../../../utils/generateToastStyles';
// import { AppDispatch } from '../../../redux/reducer/store';

import LimitSelect from '../../custom/limitSelect/limitSelect';
// import ToastPopup from '../../custom/toastPopup/toastPopup';
import Pagination from '../../pagination/pagination';
import Loader from '../../custom/loader/loader';

import '../table.scss';
import { IUserOptions } from '../../../types/interfaces';

const IS_VISIBLE_SIDEBAR = process.env.REACT_APP_IS_VISIBLE_SIDEBAR;

const TableCriteriaVerification: FC = () => {
  // const dispatch = useDispatch<AppDispatch>();

  const { isOpenSidebar, data  } = useSelector((state: IUserOptions) => state.user.user);
console.log(data.isCustomer);
  const [isPending, setIsPending] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [startPage, setStartPage] = useState<number>(1);

  // const actualLimit =
  // 	JSON.parse(localStorage.getItem('pageLimit') as string) || limit;

  // useEffect(() => {
  // 	if (status === 200) {
  // 		toast(
  // 			t => (
  // 				<ToastPopup
  // 					title='Файл успешно загружен!'
  // 					isSuccess={true}
  // 					toast={toast}
  // 					t={t}
  // 				/>
  // 			),
  // 			generateStyles(true)
  // 		);
  // 	} else if (status === 0) {
  // 		toast(
  // 			t => (
  // 				<ToastPopup
  // 					title='Ошибка загрузки файлов!'
  // 					isSuccess={false}
  // 					toast={toast}
  // 					t={t}
  // 				/>
  // 			),
  // 			generateStyles()
  // 		);
  // 	}

  // 	setTimeout(() => {
  // 		dispatch(reducerRetailOutletsStatus(null));
  // 	}, 5000);
  // }, [dispatch]);


  const handleChange = (newLimit: number, newOffset: number) => {
    setIsPending(true);
    localStorage.setItem('pageLimit', JSON.stringify(newLimit));
  };

  const handleChangeLimits = (option: { value: number }) => {
    handleChange(option.value, 0);
    setCurrentPage(1);
    setStartPage(1);
  };

  // const handleCheckboxChange = (posId: number) => {

  // };

  return (
    <>
      <div className='loader__wrapper'>
        {isPending && <Loader />}
      </div>
      <div
        className={clsx(
          JSON.parse(IS_VISIBLE_SIDEBAR as string) &&
          isOpenSidebar &&
          'active__table',
          !isOpenSidebar && 'closed__table',
          'table'
        )}
      >
        {/* {(status ||status !== null) && <Toaster
					position='top-center'
					toastOptions={{
						duration: 5000,
					}}
				/>} */}
        <div className='table__wrapper'>
          <table>
            <thead className='tunder__thead'>
              <tr className='tunder__outlets_tr'>
                <th>
                  <span className='filter__title'>id</span>
                </th>
                <th>
                  <span className='filter__title'>Наименование</span>
                </th>
                <th>
                  <span className='filter__title'>Штраф (руб.)</span>
                </th>
                <th>
                  <span className='filter__title'>Тип</span>
                </th>
                <th>
                  <span className='filter__title'>Отклонение клиентом</span>
                </th>
                <th>
                  <span className='filter__title'>Активирована</span>
                </th>
                <th>
                  <span className='filter__title'>Комментарий</span>
                </th>
                <th>
                  <span className='filter__title'>Вн. проверка</span>
                </th>
                <th>
                  <span className='filter__title'>Претензия</span>
                </th>
                <th>
                  <span className='filter__title'>Рекомендация</span>
                </th>
                <th>
                  <span className='filter__title'>Принятие</span>
                </th>
                <th>
                  <span className='filter__title'>OSA</span>
                </th>
                <th>
                  <span className='filter__title'>Комментарий при принятии отчёта</span>
                </th>
                <th>
                  <span className='filter__title'>Комментарий при формировании претензии</span>
                </th>
                <th>
                  <span className='filter__title'>Комментарий при формировании рекомендации</span>
                </th>
                <th>
                  <span className='filter__title'>Комментарий при при внутренней проверке</span>
                </th>
              </tr>
            </thead>
            {/* <tbody>
							{retailOutlets &&
								retailOutlets.map((outlet: IRetailOutlets) => (
									<tr key={outlet.posId}>
										<td>
											<input
												disabled={
													!(claims.includes('admin') ||
														claims.includes('tander:view'))
												}
												onChange={() => handleCheckboxChange(outlet.posId)}
												defaultChecked={outlet.active}
												type='checkbox'
											/>
										</td>
										<td></td>
										<td></td>
										<td></td>
										<td></td>
										<td>Установлен</td>
										<td>Установлен</td>
										<td>Установлен</td>
										<td>Не установлен</td>
										<td></td>
										<td></td>
										<td></td>
										<td></td>
										<td>Установлен</td>
										<td>Установлен</td>
										<td>Установлен</td>
									</tr>
								))}
						</tbody> */}
          </table>
        </div>
        <div className='pagination'>
          <div className='pagination__str'>
            <span>Отображать строки</span>
            <LimitSelect limit={10} propsChange={handleChangeLimits} />
          </div>
          <Pagination
            setCurrentPage={setCurrentPage}
            setStartPage={setStartPage}
            handleChange={handleChange}
            count={10}
            currentPage={currentPage}
            startPage={startPage}
            limit={10}
          />
        </div>
      </div>
    </>
  );
};

export default TableCriteriaVerification;
